import request from '@/utils/request'

/************项目管理*****************/ 
//密码登录
export function passwordLogin(data) {
    return request({
        url: '/login',
        method: 'post',
        data: data
    })
}
//密码登录
export function phoneLogin(data) {
    return request({
        url: '/phoneLogin',
        method: 'post',
        data: data
    })
}
//发送验证码
export function sendCode(query) {
    return request({
        url: '/sendCode',
        method: 'get',
        params: query
    })
}
//获取用户信息
export function getInfo(query) {
    return request({
        url: '/getInfo',
        method: 'get',
        params: query
    })
}
//退出登录
export function logout(query) {
    return request({
        url: '/logout',
        method: 'get',
        params: query
    })
}
// 获取用户权限
export function getUserAuth(query) {
    return request({
        url: '/getUserAuth',
        method: 'get',
        params: query
    })
}



